const VERIFIER_KEY = 'google_pkce_verifier';

function base64url(bytes: Uint8Array): string {
  let binary = '';
  for (const b of bytes) binary += String.fromCharCode(b);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function googleRedirectUri(): string {
  return `${window.location.origin}/auth/google/callback`;
}

/** Build the Google authorization URL and stash the PKCE verifier (spec 3.1). */
export async function buildGoogleAuthUrl(): Promise<string> {
  const verifier = base64url(crypto.getRandomValues(new Uint8Array(32)));
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  const challenge = base64url(new Uint8Array(digest));
  sessionStorage.setItem(VERIFIER_KEY, verifier);

  const params = new URLSearchParams({
    client_id: (import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined) ?? '',
    redirect_uri: googleRedirectUri(),
    response_type: 'code',
    scope: 'openid email profile',
    code_challenge: challenge,
    code_challenge_method: 'S256',
    prompt: 'select_account',
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}

export function takeStoredVerifier(): string | undefined {
  const v = sessionStorage.getItem(VERIFIER_KEY) ?? undefined;
  sessionStorage.removeItem(VERIFIER_KEY);
  return v;
}
